import React, { useState } from 'react';
import styles from "assets/scss/task_management.module.css";
import TeamProgressCard from './TeamProgressCard';
import { Trans } from 'react-i18next';

function TeamProgress({ tasks, fetchLabels, fetchEmployees, groups, buckets, userPermission, activeTab }) {

    return (
        <div className={styles.bucketContainer}>
            <div className={`mb-1 mr-4 text-black rounded-2`}>
                <div className={styles.taskBucket}>
                    <span className={styles.bucketName}><Trans>Assigned</Trans></span>
                </div>
                <div className={styles.taskList}>
                    {tasks.assigned.map((task) => (
                        <TeamProgressCard
                            key={task.task.id}
                            task={task.task}
                            fetchLabels={fetchLabels}
                            fetchEmployees={fetchEmployees}
                            groups={groups}
                            buckets={buckets}
                            userPermission={userPermission}
                            activeTab={activeTab}
                        />
                    ))}
                </div>
            </div>
            <div className={styles.bucket}>
                <div className={styles.taskBucket}>
                    <span className={styles.bucketName}><Trans>In Progress</Trans></span>
                </div>
                <div className={styles.taskList}>
                    {tasks.inProgress.map((task) => (
                        <TeamProgressCard
                            key={task.id}
                            task={task}
                            fetchLabels={fetchLabels}
                            fetchEmployees={fetchEmployees}
                            buckets={buckets}
                        />
                    ))}


                </div>
            </div>

            <div className={styles.bucket}>
                <div className={styles.taskBucket}>
                    <span className={styles.bucketName}><Trans>Completed</Trans></span>
                </div>
                <div className={styles.taskList}>
                    {tasks.completed.map((task) => (
                        <TeamProgressCard
                            key={task.id}
                            task={task}
                            fetchLabels={fetchLabels}
                            fetchEmployees={fetchEmployees}
                            buckets={buckets}
                        />
                    ))}
                    
                    
                </div>
            </div>
        </div>
    );
}

export default TeamProgress;
